import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const MainWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;

  ${themeGet('breakpoints.tablet')} {
    flex-direction: column;
  }
`

export const LeftWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-basis: 59%;
  border-radius: 0.3125rem;
  background-color: #eef0f2;
  width: 26.5rem;
  padding: 2.125rem 1.75rem 1.375rem 1.75rem;
  ${themeGet('breakpoints.tablet')} {
    width: auto;
  }
  h2 {
    color: #002855;
    font-family: ${themeGet('sharpSlabExtrabold')};
    font-size: 26px;
    letter-spacing: 0.5px;
    line-height: 32px;
  }
`

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 41%;
  box-sizing: border-box;
  padding: 1.9375rem 1.75rem 1.8125rem 1.75rem;
  ${themeGet('breakpoints.tablet')} {
    margin-top: 0.875rem;
    padding-left: 0;

    p[label='Administrator'] {
      margin-bottom: 1.3125rem;
      padding-left: 1.5625rem;
    }

    p[label='Leader Team'] {
      margin-bottom: 0.5rem;
      padding-left: 1.5625rem;
    }

    p[label='Teacher'] {
      margin-bottom: 0.5rem;
      padding-left: 1.5625rem;
    }
  }
`

export const StyledCloseButton = styled.button`
  & svg {
    color: ${themeGet('colors.blue')};
    height: 0.75rem;
    width: 0.75rem;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: auto;
  min-height: 2.6875rem;

  ${themeGet('breakpoints.tablet')} {
    justify-content: center;
    flex-direction: row;
  }
`

export const AddSingleUserButton = styled.button`
  margin-left: 1.25rem;
  padding: 0.5625rem 0.8125rem 0.375rem;
  width: 9.313rem;
  height: 2.6875rem;
  background-color: #002855;
  box-sizing: border-box;
  border: 2px solid ${themeGet('colors.darkBlue')};
  border-radius: 5px;
  color: #ffffff;
  font-family: ${themeGet('textFontFamily')};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;

  &:not([disabled]):hover {
    background-color: transparent;
    border: 2px solid #999999;
    color: #999999;
  }

  ${themeGet('breakpoints.tablet')} {
    margin-left: 0.75rem;
    padding: 0.125rem 2rem 0 2rem;
  }
`

export const AddMultipleUsersButton = styled(AddSingleUserButton)`
  ${themeGet('breakpoints.tablet')} {
    margin-left: 0.75rem;
    padding: 0.125rem 1.7rem 0 1.7rem;
  }
`

export const CancelButton = styled.button`
  background-color: transparent;
  max-width: 9.375rem;
  padding: 0.5625rem 0.8125rem 0.375rem;
  width: 6.875rem;
  color: #999999;
  font-family: ${themeGet('textFontFamily')};
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  box-sizing: border-box;
  border: 2px solid #999999;
  border-radius: 5px;

  &:not([disabled]):hover {
    background-color: ${themeGet('colors.darkBlue')};
    border-color: ${themeGet('colors.darkBlue')};
    color: ${themeGet('colors.white')};
  }

  ${themeGet('breakpoints.tablet')} {
    padding: 0.125rem 2.4rem 0 2.4rem;
    width: 8.75rem;
  }
`
